import React from 'react';

const LoginSubText = ({ children, margin }) => {
	return <p className={`mt-${margin ? margin : "xl"} text-align-center font-size-body-s`}>{children}</p>;
};

export default LoginSubText;